export const industryTranslations = {
    "(Khách sạn) Tiếp khách, quản lý vệ sinh": {
        "vi": "(Khách sạn) Tiếp khách, quản lý vệ sinh",
        "bn": "হোটেলে অতিথি সেবা ও পরিষ্কার ব্যবস্থাপনা"
    },
    "Biên dịch, phiên dịch": {
        "vi": "Biên dịch, phiên dịch",
        "bn": "অনুবাদ ও দোভাষী"
    },
    "Biên tập": {
        "vi": "Biên tập",
        "bn": "সম্পাদনা"
    },
    "Blockchain": {
        "vi": "Blockchain",
        "bn": "ব্লকচেইন"
    },
    "BrSE (Bridge System Engineer)": {
        "vi": "BrSE (Bridge System Engineer)",
        "bn": "ব্রিজ সিস্টেম ইঞ্জিনিয়ার (BrSE)"
    },
    "Business Analyst (BA)": {
        "vi": "Business Analyst (BA)",
        "bn": "বিজনেস অ্যানালিস্ট (BA)"
    },
    "Buồng phòng khách sạn": {
        "vi": "Buồng phòng khách sạn",
        "bn": "হোটেল রুম পরিষেবা"
    },
    "Buộc thép": {
        "vi": "Buộc thép",
        "bn": "ইস্পাত বাঁধাই"
    },
    "Bác sĩ": {
        "vi": "Bác sĩ",
        "bn": "চিকিৎসক"
    },
    "Bác sĩ chỉnh thị lực": {
        "vi": "Bác sĩ chỉnh thị lực",
        "bn": "অকিউমেট্রিস্ট"
    },
    "Bán hàng miễn thuế": {
        "vi": "Bán hàng miễn thuế",
        "bn": "ডিউটি-ফ্রি সেলস"
    },
    "Bánh gạo": {
        "vi": "Bánh gạo",
        "bn": "চালের কেক"
    },
    "Bánh kẹo": {
        "vi": "Bánh kẹo",
        "bn": "মিষ্টি ও কনফেকশনারি"
    },
    "Bánh ngọt": {
        "vi": "Bánh ngọt",
        "bn": "মিষ্টি পেস্ট্রি"
    },
    "Báo chí": {
        "vi": "Báo chí",
        "bn": "সাংবাদিকতা"
    },
    "Báo chí - truyền thông - marketing": {
        "vi": "Báo chí - truyền thông - marketing",
        "bn": "সাংবাদিকতা, মিডিয়া এবং মার্কেটিং"
    },
    "Báo chí, truyền thông, marketing": {
        "vi": "Báo chí, truyền thông, marketing",
        "bn": "মিডিয়া এবং মার্কেটিং"
    },
    "Bê tông": {
        "vi": "Bê tông",
        "bn": "কংক্রিট"
    },
    "Bản mạch in": {
        "vi": "Bản mạch in",
        "bn": "প্রিন্টেড সার্কিট বোর্ড (PCB)"
    },
    "Bảo dưỡng ô tô": {
        "vi": "Bảo dưỡng ô tô",
        "bn": "গাড়ি রক্ষণাবেক্ষণ"
    },
    "Bảo trì hệ thống điện": {
        "vi": "Bảo trì hệ thống điện",
        "bn": "বৈদ্যুতিক সিস্টেম রক্ষণাবেক্ষণ"
    },
    "Bảo trì máy móc": {
        "vi": "Bảo trì máy móc",
        "bn": "যন্ত্রপাতি রক্ষণাবেক্ষণ"
    },
    "Bảo trì đường sắt": {
        "vi": "Bảo trì đường sắt",
        "bn": "রেলপথ রক্ষণাবেক্ষণ"
    },
    "Bếp viện": {
        "vi": "Bếp viện",
        "bn": "হাসপাতালের রান্নাঘর"
    },
    "COO (Chief Operation Officer)": {
        "vi": "COO (Chief Operation Officer)",
        "bn": "চিফ অপারেটিং অফিসার (COO)"
    },
    "CTO (Chief Technology Officer)": {
        "vi": "CTO (Chief Technology Officer)",
        "bn": "চিফ টেকনোলজি অফিসার (CTO)"
    },
    "Chiết xuất thuỷ sản": {
        "vi": "Chiết xuất thuỷ sản",
        "bn": "সামুদ্রিক পণ্য থেকে নির্যাস তৈরি"
    },
    "Chuyên viên pháp lý hành chính": {
        "vi": "Chuyên viên pháp lý hành chính",
        "bn": "প্রশাসনিক আইনি বিশেষজ্ঞ"
    },
    "Chuyên viên phục hình": {
        "vi": "Chuyên viên phục hình",
        "bn": "প্রোস্থেটিক্স বিশেষজ্ঞ"
    },
    "Chăm sóc người già": {
        "vi": "Chăm sóc người già",
        "bn": "প্রবীণ সেবা"
    },
    "Chăn ga gối đệm": {
        "vi": "Chăn ga gối đệm",
        "bn": "বিছানা চাদর ও বালিশ"
    },
    "Chăn nuôi": {
        "vi": "Chăn nuôi",
        "bn": "পশুপালন"
    },
    "Chăn nuôi bò": {
        "vi": "Chăn nuôi bò",
        "bn": "গরু পালন"
    },
    "Chăn nuôi bò sữa": {
        "vi": "Chăn nuôi bò sữa",
        "bn": "দুগ্ধ গরু পালন"
    },
    "Chăn nuôi gà": {
        "vi": "Chăn nuôi gà",
        "bn": "মুরগি পালন"
    },
    "Chăn nuôi lợn": {
        "vi": "Chăn nuôi lợn",
        "bn": "শূকর পালন"
    },
    "Chạy bàn": {
        "vi": "Chạy bàn",
        "bn": "ওয়েটার/সার্ভিং"
    },
    "Chế biến cá": {
        "vi": "Chế biến cá",
        "bn": "মাছ প্রক্রিয়াজাতকরণ"
    },
    "Chế biến gia cầm": {
        "vi": "Chế biến gia cầm",
        "bn": "পোলট্রি প্রক্রিয়াজাতকরণ"
    },
    "Chế biến sushi": {
        "vi": "Chế biến sushi",
        "bn": "সুশি প্রস্তুত করা"
    },
    "Chế biến thuỷ sản sống": {
        "vi": "Chế biến thuỷ sản sống",
        "bn": "তাজা সামুদ্রিক খাদ্য প্রক্রিয়াজাতকরণ"
    },
    "Chế biến thịt bò, lợn": {
        "vi": "Chế biến thịt bò, lợn",
        "bn": "গরু ও শূকরের মাংস প্রক্রিয়াজাতকরণ"
    },
    "Chế biến đồ ăn sẵn": {
        "vi": "Chế biến đồ ăn sẵn",
        "bn": "প্রস্তুত খাবার প্রক্রিয়াজাতকরণ"
    },
    "Chế tạo Vật liệu": {
        "vi": "Chế tạo Vật liệu",
        "bn": "উপাদান উৎপাদন"
    },
    "Chế tạo kim loại tấm": {
        "vi": "Chế tạo kim loại tấm",
        "bn": "শীট মেটাল ফ্যাব্রিকেশন"
    },
    "Chế tạo máy": {
        "vi": "Chế tạo máy",
        "bn": "মেশিন নির্মাণ"
    },
    "Chống thấm": {
        "vi": "Chống thấm",
        "bn": "ওয়াটারপ্রুফিং"
    },
    "Cuộn dây máy điện quay": {
        "vi": "Cuộn dây máy điện quay",
        "bn": "ইলেকট্রিক মোটরের কয়েল প্যাঁচানো"
    },
    "Các ngành nghề khác": {
        "vi": "Các ngành nghề khác",
        "bn": "অন্যান্য শিল্প"
    },
    "Câu cá ngừ cần và dây": {
        "vi": "Câu cá ngừ cần và dây",
        "bn": "ছিপ ও সুতা দিয়ে টুনা মাছ ধরা"
    },
    "Câu mực": {
        "vi": "Câu mực",
        "bn": "স্কুইড মাছ ধরা"
    },
    "Câu tôm, cua bằng lồng": {
        "vi": "Câu tôm, cua bằng lồng",
        "bn": "খাঁচা দিয়ে চিংড়ি ও কাঁকড়া ধরা"
    },
    "Công chức": {
        "vi": "Công chức",
        "bn": "সরকারি কর্মচারী"
    },
    "Công nghệ cơ khí": {
        "vi": "Công nghệ cơ khí",
        "bn": "মেকানিক্যাল প্রযুক্তি"
    },
    "Công nghệ môi trường": {
        "vi": "Công nghệ môi trường",
        "bn": "পরিবেশ প্রযুক্তি"
    },
    "Công nghệ nông, lâm, ngư nghiệp": {
        "vi": "Công nghệ nông, lâm, ngư nghiệp",
        "bn": "কৃষি, বনজ ও মৎস্য প্রযুক্তি"
    },
    "Công nghệ sản xuất": {
        "vi": "Công nghệ sản xuất",
        "bn": "উৎপাদন প্রযুক্তি"
    },
    "Công nghệ thông tin": {
        "vi": "Công nghệ thông tin",
        "bn": "তথ্য প্রযুক্তি"
    },
    "Công nghệ thông tin (IT)": {
        "vi": "Công nghệ thông tin (IT)",
        "bn": "তথ্য প্রযুক্তি (আইটি)"
    },
    "Công nghệ xây dựng của nước ngoài": {
        "vi": "Công nghệ xây dựng của nước ngoài",
        "bn": "বিদেশী নির্মাণ প্রযুক্তি"
    },
    "Công nghệ ô tô": {
        "vi": "Công nghệ ô tô",
        "bn": "অটোমোবাইল প্রযুক্তি"
    },
    "Công nhân Nông, Lâm, Ngư nghiệp": {
        "vi": "Công nhân Nông, Lâm, Ngư nghiệp",
        "bn": "কৃষি, বনজ ও মৎস্য কর্মী"
    },
    "Công nhân chăn nuôi đặc khu": {
        "vi": "Công nhân chăn nuôi đặc khu",
        "bn": "বিশেষ অঞ্চলের পশুপালন কর্মী"
    },
    "Công nhân kết cấu xây dựng": {
        "vi": "Công nhân kết cấu xây dựng",
        "bn": "নির্মাণ কাঠামো কর্মী"
    },
    "Công nhân sản xuất, gia công kim loại": {
        "vi": "Công nhân sản xuất, gia công kim loại",
        "bn": "ধাতু উৎপাদন ও প্রক্রিয়াকরণ কর্মী"
    },
    "Công nhân sản xuất, gia công sản phẩm (trừ kim loại, máy móc)": {
        "vi": "Công nhân sản xuất, gia công sản phẩm (trừ kim loại, máy móc)",
        "bn": "পণ্য উৎপাদন ও প্রক্রিয়াকরণ কর্মী (ধাতু ও যন্ত্রপাতি ব্যতীত)"
    },
    "Công nhân trồng trọt đặc khu": {
        "vi": "Công nhân trồng trọt đặc khu",
        "bn": "বিশেষ অঞ্চলের ফসল উৎপাদন কর্মী"
    },
    "Công nhân xây dựng (trừ khung công trình)": {
        "vi": "Công nhân xây dựng (trừ khung công trình)",
        "bn": "নির্মাণ কর্মী (ফ্রেমওয়ার্ক ব্যতীত)"
    },
    "Công nhân xây dựng mỏ tổng hợp": {
        "vi": "Công nhân xây dựng mỏ tổng hợp",
        "bn": "সাধারণ খনি নির্মাণ কর্মী"
    },
    "Công nhân xây dựng nước ngoài": {
        "vi": "Công nhân xây dựng nước ngoài",
        "bn": "বিদেশী নির্মাণ কর্মী"
    },
    "Công nhân đóng tàu nước ngoài": {
        "vi": "Công nhân đóng tàu nước ngoài",
        "bn": "বিদেশী জাহাজ নির্মাণ কর্মী"
    },
    "Công việc cưa gỗ": {
        "vi": "Công việc cưa gỗ",
        "bn": "কাঠ কাটার কাজ"
    },
    "Công việc mùa hè": {
        "vi": "Công việc mùa hè",
        "bn": "সামার জব"
    },
    "Công việc trước khi dệt": {
        "vi": "Công việc trước khi dệt",
        "bn": "বুননের পূর্ববর্তী কাজ"
    },
    "Công việc trước kéo sợi": {
        "vi": "Công việc trước kéo sợi",
        "bn": "সুতা কাটার পূর্ববর্তী কাজ"
    },
    "Cơ khí": {
        "vi": "Cơ khí",
        "bn": "যান্ত্রিক কাজ"
    },
    "Cơ khí & Kim loại": {
        "vi": "Cơ khí & Kim loại",
        "bn": "যন্ত্রপাতি এবং ধাতু শিল্প"
    },
    "Cơ khí, chế tạo máy": {
        "vi": "Cơ khí, chế tạo máy",
        "bn": "মেকানিক্যাল ও মেশিনারি"
    },
    "Cơ khí, kim loại": {
        "vi": "Cơ khí, kim loại",
        "bn": "মেকালিকাল ও মেটাল"
    },
    "Cơ khí, máy móc": {
        "vi": "Cơ khí, máy móc",
        "bn": "মেকানিক্যাল ও মেশিনারি"
    },
    "Cơm hộp": {
        "vi": "Cơm hộp",
        "bn": "বেন্টো বক্স"
    },
    "Cơm nắm": {
        "vi": "Cơm nắm",
        "bn": "চালের বল (অনিগিরি)"
    },
    "Cầu đường": {
        "vi": "Cầu đường",
        "bn": "রাস্তা ও সেতু"
    },
    "Cốp pha": {
        "vi": "Cốp pha",
        "bn": "ফর্মওয়ার্ক"
    },
    "Cốp pha công trình": {
        "vi": "Cốp pha công trình",
        "bn": "ফর্মওয়ার্ক"
    },
    "Cửa hàng siêu thị": {
        "vi": "Cửa hàng siêu thị",
        "bn": "সুপারমার্কেট দোকান"
    },
    "Digital Marketing": {
        "vi": "Digital Marketing",
        "bn": "ডিজিটাল মার্কেটিং"
    },
    "Dán tường": {
        "vi": "Dán tường",
        "bn": "দেয়াল লাগানো কাজ"
    },
    "Dược sĩ": {
        "vi": "Dược sĩ",
        "bn": "ফার্মাসিস্ট"
    },
    "Dập khuôn kim loại": {
        "vi": "Dập khuôn kim loại",
        "bn": "মেটাল স্ট্যাম্পিং"
    },
    "Dập kim loại": {
        "vi": "Dập kim loại",
        "bn": "মেটাল স্ট্যাম্পিং"
    },
    "Dệt hoàn thiện": {
        "vi": "Dệt hoàn thiện",
        "bn": "টেক্সটাইল ফিনিশিং"
    },
    "Dệt kim máy sợi dọc": {
        "vi": "Dệt kim máy sợi dọc",
        "bn": "ওয়ার্প নিটিং"
    },
    "Dệt may": {
        "vi": "Dệt may",
        "bn": "টেক্সটাইল এবং পোশাক শিল্প"
    },
    "Dịch vụ bán hàng": {
        "vi": "Dịch vụ bán hàng",
        "bn": "বিক্রয় পরিষেবা"
    },
    "Dịch vụ khách hàng tổng hợp": {
        "vi": "Dịch vụ khách hàng tổng hợp",
        "bn": "সাধারণ গ্রাহক পরিষেবা"
    },
    "Dịch vụ khách sạn": {
        "vi": "Dịch vụ khách sạn",
        "bn": "হোটেল পরিষেবা"
    },
    "Dịch vụ pháp lý": {
        "vi": "Dịch vụ pháp lý",
        "bn": "আইনি পরিষেবা"
    },
    "Dọn dẹp khoang hành khách": {
        "vi": "Dọn dẹp khoang hành khách",
        "bn": "যাত্রী কেবিন পরিষ্কার"
    },
    "Dựng giàn giáo": {
        "vi": "Dựng giàn giáo",
        "bn": "স্ক্যাফোল্ডিং স্থাপন"
    },
    "Gia công cơ khí": {
        "vi": "Gia công cơ khí",
        "bn": "মেশিনিং কাজ"
    },
    "Gia công dệt": {
        "vi": "Gia công dệt",
        "bn": "টেক্সটাইল প্রক্রিয়াকরণ"
    },
    "Gia công khung thép": {
        "vi": "Gia công khung thép",
        "bn": "স্টিল ফ্রেম প্রক্রিয়াকরণ"
    },
    "Gia công khung thép trong xưởng": {
        "vi": "Gia công khung thép trong xưởng",
        "bn": "কারখানায় স্টিল ফ্রেম প্রক্রিয়াকরণ"
    },
    "Gia công kim loại - Tekko": {
        "vi": "Gia công kim loại - Tekko",
        "bn": "ধাতু প্রক্রিয়াজাতকরণ (টেক্কো)"
    },
    "Gia công sản phẩm gỗ": {
        "vi": "Gia công sản phẩm gỗ",
        "bn": "কাঠের পণ্য প্রক্রিয়াজাতকরণ"
    },
    "Gia công sắt trong xưởng": {
        "vi": "Gia công sắt trong xưởng",
        "bn": "কারখানায় লোহা প্রক্রিয়াকরণ"
    },
    "Gia công sợi hỗn hợp": {
        "vi": "Gia công sợi hỗn hợp",
        "bn": "মিশ্রিত সুতা প্রক্রিয়াকরণ"
    },
    "Gia công tinh": {
        "vi": "Gia công tinh",
        "bn": "সূক্ষ্ম মেশিনিং"
    },
    "Gia công vật liệu đá": {
        "vi": "Gia công vật liệu đá",
        "bn": "পাথর প্রক্রিয়াজাতকরণ"
    },
    "Gia công ép đùn": {
        "vi": "Gia công ép đùn",
        "bn": "এক্সট্রুশন প্রক্রিয়াকরণ"
    },
    "Gia công ép đùn cao su": {
        "vi": "Gia công ép đùn cao su",
        "bn": "রাবার এক্সট্রুশন প্রক্রিয়াকরণ"
    },
    "Gia công đường ống": {
        "vi": "Gia công đường ống",
        "bn": "পাইপ প্রক্রিয়াজাতকরণ"
    },
    "Gia công đồ gia dụng": {
        "vi": "Gia công đồ gia dụng",
        "bn": "গৃহস্থালী পণ্যের প্রক্রিয়াজাতকরণ"
    },
    "Gia công đồ xa xỉ": {
        "vi": "Gia công đồ xa xỉ",
        "bn": "বিলাসবহুল পণ্য প্রক্রিয়াকরণ"
    },
    "Gia công đồ ăn liền": {
        "vi": "Gia công đồ ăn liền",
        "bn": "ইনস্ট্যান্ট খাবার উৎপাদন"
    },
    "Giàn giáo": {
        "vi": "Giàn giáo",
        "bn": "ভারা"
    },
    "Giám sát thi công": {
        "vi": "Giám sát thi công",
        "bn": "নির্মাণ তত্ত্বাবধায়ক"
    },
    "Giáo dục - đào tạo": {
        "vi": "Giáo dục - đào tạo",
        "bn": "শিক্ষা এবং প্রশিক্ষণ"
    },
    "Giáo dục, đào tạo": {
        "vi": "Giáo dục, đào tạo",
        "bn": "শিক্ষা এবং প্রশিক্ষণ"
    },
    "Giúp việc gia đình đặc khu": {
        "vi": "Giúp việc gia đình đặc khu",
        "bn": "বিশেষ অঞ্চলের গৃহকর্মী"
    },
    "Giăm bông, xúc xích...": {
        "vi": "Giăm bông, xúc xích...",
        "bn": "হ্যাম, সসেজ ইত্যাদি"
    },
    "Giảng dạy có chứng chỉ": {
        "vi": "Giảng dạy có chứng chỉ",
        "bn": "প্রত্যয়িত শিক্ষকতা"
    },
    "Giảng dạy ngoài cơ sở giáo dục": {
        "vi": "Giảng dạy ngoài cơ sở giáo dục",
        "bn": "অ-প্রাতিষ্ঠানিক শিক্ষা"
    },
    "Giảng dạy ngôn ngữ tại Tiểu học, THCS, PTTH": {
        "vi": "Giảng dạy ngôn ngữ tại Tiểu học, THCS, PTTH",
        "bn": "স্কুলে ভাষা শিক্ষা"
    },
    "Giảng dạy trường dạy nghề (Senmon)": {
        "vi": "Giảng dạy trường dạy nghề (Senmon)",
        "bn": "ভোকেশনাল স্কুলে শিক্ষকতা"
    },
    "Giảng dạy trường học các loại": {
        "vi": "Giảng dạy trường học các loại",
        "bn": "বিভিন্ন ধরণের স্কুলে শিক্ষকতা"
    },
    "Giảng dạy trường quốc tế": {
        "vi": "Giảng dạy trường quốc tế",
        "bn": "আন্তর্জাতিক স্কুলে শিক্ষকতা"
    },
    "Giảng dạy đại học": {
        "vi": "Giảng dạy đại học",
        "bn": "বিশ্ববিদ্যালয়ে শিক্ষকতা"
    },
    "Gỗ ép": {
        "vi": "Gỗ ép",
        "bn": "প্লাইউড"
    },
    "Hoàn thiện dụng cụ nung chảy": {
        "vi": "Hoàn thiện dụng cụ nung chảy",
        "bn": "গলন যন্ত্রপাতি ফিনিশিং"
    },
    "Hoàn thiện khuôn": {
        "vi": "Hoàn thiện khuôn",
        "bn": "মোল্ড ফিনিশিং"
    },
    "Hoàn thiện nội thất": {
        "vi": "Hoàn thiện nội thất",
        "bn": "ইন্টেরিয়র ফিনিশিং"
    },
    "Hoàn thiện sàn nhựa": {
        "vi": "Hoàn thiện sàn nhựa",
        "bn": "প্লাস্টিক ফ্লোর ফিনিশিং"
    },
    "Hoàn thiện sàn thảm": {
        "vi": "Hoàn thiện sàn thảm",
        "bn": "কার্পেট ফ্লোর ফিনিশিং"
    },
    "Hoàn thiện sản phẩm ép đùn": {
        "vi": "Hoàn thiện sản phẩm ép đùn",
        "bn": "এক্সট্রুশন পণ্যের ফিনিশিং"
    },
    "Hoàn thiện ván": {
        "vi": "Hoàn thiện ván",
        "bn": "বোর্ড ফিনিশিং"
    },
    "Hoá học làm xưởng": {
        "vi": "Hoá học làm xưởng",
        "bn": "শিল্প রসায়ন"
    },
    "Hoạt động khởi nghiệp": {
        "vi": "Hoạt động khởi nghiệp",
        "bn": "স্টার্টআপ কার্যক্রম"
    },
    "Huấn luyện động vật": {
        "vi": "Huấn luyện động vật",
        "bn": "পশু প্রশিক্ষক"
    },
    "Hàn": {
        "vi": "Hàn",
        "bn": "ওয়েল্ডিং (ঝালাই)"
    },
    "Hàn bán tự động": {
        "vi": "Hàn bán tự động",
        "bn": "সেমি-অটোমেটিক ওয়েল্ডিং"
    },
    "Hàn khung thép": {
        "vi": "Hàn khung thép",
        "bn": "স্টিল ফ্রেম ওয়েল্ডিং"
    },
    "Hàn khung thép trên cao": {
        "vi": "Hàn khung thép trên cao",
        "bn": "উচ্চতায় স্টিল ফ্রেম ওয়েল্ডিং"
    },
    "Hàn khí": {
        "vi": "Hàn khí",
        "bn": "গ্যাস ওয়েল্ডিং"
    },
    "Hàn kết cấu": {
        "vi": "Hàn kết cấu",
        "bn": "স্ট্রাকচারাল ওয়েল্ডিং"
    },
    "Hàn thủ công": {
        "vi": "Hàn thủ công",
        "bn": "ম্যানুয়াল ওয়েল্ডিং"
    },
    "Hàn tàu": {
        "vi": "Hàn tàu",
        "bn": "জাহাজ ওয়েল্ডিং"
    },
    "Hàn tủ điện": {
        "vi": "Hàn tủ điện",
        "bn": "ইলেকট্রিক কেবিনেট ওয়েল্ডিং"
    },
    "Hàn xì": {
        "vi": "Hàn xì",
        "bn": "ঝালাই"
    },
    "Hàng không": {
        "vi": "Hàng không",
        "bn": "বিমান চালনা"
    },
    "Hàng hóa hàng không": {
        "vi": "Hàng hóa hàng không",
        "bn": "বিমান কার্গো"
    },
    "Hành chính - văn phòng": {
        "vi": "Hành chính - văn phòng",
        "bn": "প্রশাসনিক এবং অফিস"
    },
    "Hành chính, văn phòng": {
        "vi": "Hành chính, văn phòng",
        "bn": "প্রশাসনিক এবং অফিস"
    },
    "Hành lý khách sạn": {
        "vi": "Hành lý khách sạn",
        "bn": "হোটেলের লাগেজ পরিষেবা"
    },
    "Há cảo": {
        "vi": "Há cảo",
        "bn": "ডাম্পলিং"
    },
    "Hút nước ngầm công trình": {
        "vi": "Hút nước ngầm công trình",
        "bn": "নির্মাণস্থলে ভূগর্ভস্থ পানি নিষ্কাশন"
    },
    "Hướng dẫn nghiên cứu": {
        "vi": "Hướng dẫn nghiên cứu",
        "bn": "গবেষণা গাইড"
    },
    "Hướng dẫn thể thao": {
        "vi": "Hướng dẫn thể thao",
        "bn": "স্পোর্টস ইনস্ট্রাক্টর"
    },
    "Hậu cần vận tải": {
        "vi": "Hậu cần vận tải",
        "bn": "পরিবহন লজিস্টিকস"
    },
    "Hỗ trợ mặt đất máy bay": {
        "vi": "Hỗ trợ mặt đất máy bay",
        "bn": "বিমান গ্রাউন্ড সাপোর্ট"
    },
    "Hộ lý": {
        "vi": "Hộ lý",
        "bn": "পরিচর্যাকারী"
    },
    "IT": {
        "vi": "IT",
        "bn": "আইটি"
    },
    "IT Support": {
        "vi": "IT Support",
        "bn": "আইটি সাপোর্ট"
    },
    "IT làm xưởng": {
        "vi": "IT làm xưởng",
        "bn": "শিল্প আইটি"
    },
    "ITM (Information Technical Manager)": {
        "vi": "ITM (Information Technical Manager)",
        "bn": "তথ্য প্রযুক্তি ব্যবস্থাপক (ITM)"
    },
    "In gốm": {
        "vi": "In gốm",
        "bn": "সিরামিক প্রিন্টিং"
    },
    "In offset": {
        "vi": "In offset",
        "bn": "অফসেট প্রিন্টিং"
    },
    "In vỏ bánh kẹo": {
        "vi": "In vỏ bánh kẹo",
        "bn": "কনফেকশনারি প্যাকেট প্রিন্টিং"
    },
    "In ấn": {
        "vi": "In ấn",
        "bn": "মুদ্রণ"
    },
    "In ống đồng": {
        "vi": "In ống đồng",
        "bn": "গ্রাভিউর প্রিন্টিং"
    },
    "Khoan giếng máy dập": {
        "vi": "Khoan giếng máy dập",
        "bn": "মেশিন দিয়ে কূপ খনন (হ্যামার)"
    },
    "Khoan giếng máy khoan": {
        "vi": "Khoan giếng máy khoan",
        "bn": "ড্রিল মেশিন দিয়ে কূপ খনন"
    },
    "Khoan khảo sát dầu mỏ, năng lượng": {
        "vi": "Khoan khảo sát dầu mỏ, năng lượng",
        "bn": "পেট্রোলিয়াম ও জ্বালানি অনুসন্ধান ড্রিলিং"
    },
    "Khu nghỉ dưỡng": {
        "vi": "Khu nghỉ dưỡng",
        "bn": "রিসোর্ট"
    },
    "Khung chắn toà nhà": {
        "vi": "Khung chắn toà nhà",
        "bn": "ভবনের সুরক্ষা কাঠামো"
    },
    "Khách sạn - lưu trú": {
        "vi": "Khách sạn - lưu trú",
        "bn": "হোটেল এবং আবাসন"
    },
    "Khách sạn, lưu trú": {
        "vi": "Khách sạn, lưu trú",
        "bn": "হোটেল এবং আবাসন"
    },
    "Khảo sát": {
        "vi": "Khảo sát",
        "bn": "জরিপ"
    },
    "Khảo sát đất đai, nhà ở": {
        "vi": "Khảo sát đất đai, nhà ở",
        "bn": "জমি ও আবাসন জরিপ"
    },
    "Kinh doanh - kinh tế": {
        "vi": "Kinh doanh - kinh tế",
        "bn": "ব্যবসা এবং অর্থনীতি"
    },
    "Kinh doanh kế toán": {
        "vi": "Kinh doanh kế toán",
        "bn": "ব্যবসায়িক হিসাবরক্ষণ"
    },
    "Kinh doanh, kinh tế": {
        "vi": "Kinh doanh, kinh tế",
        "bn": "ব্যবসা এবং অর্থনীতি"
    },
    "Kinh tế": {
        "vi": "Kinh tế",
        "bn": "অর্থনীতি"
    },
    "Kinh tế làm xưởng": {
        "vi": "Kinh tế làm xưởng",
        "bn": "শিল্প অর্থনীতি"
    },
    "Kiến trúc sư": {
        "vi": "Kiến trúc sư",
        "bn": "স্থপতি"
    },
    "Kiểm tra linh kiện ô tô": {
        "vi": "Kiểm tra linh kiện ô tô",
        "bn": "গাড়ির যন্ত্রাংশ পরিদর্শন"
    },
    "Kiểm tra máy móc": {
        "vi": "Kiểm tra máy móc",
        "bn": "যন্ত্রপাতি পরিদর্শন"
    },
    "Kiểm tra sản phẩm nhựa": {
        "vi": "Kiểm tra sản phẩm nhựa",
        "bn": "প্লাস্টিক পণ্য পরিদর্শন"
    },
    "Kéo sợi tinh": {
        "vi": "Kéo sợi tinh",
        "bn": "ফাইন স্পিনিং"
    },
    "Kế toán công chứng": {
        "vi": "Kế toán công chứng",
        "bn": "চার্টার্ড অ্যাকাউন্ট্যান্ট"
    },
    "Kế toán công chứng nước ngoài": {
        "vi": "Kế toán công chứng nước ngoài",
        "bn": "বিদেশী চার্টার্ড অ্যাকাউন্ট্যান্ট"
    },
    "Kế toán thuế": {
        "vi": "Kế toán thuế",
        "bn": "ট্যাক্স অ্যাকাউন্ট্যান্ট"
    },
    "Kỹ thuật Khảo sát": {
        "vi": "Kỹ thuật Khảo sát",
        "bn": "জরিপ প্রকৌশল"
    },
    "Kỹ thuật Kiến trúc": {
        "vi": "Kỹ thuật Kiến trúc",
        "bn": "স্থাপত্য প্রকৌশল"
    },
    "Kỹ thuật Kiến trúc, Xây dựng, Khảo sát": {
        "vi": "Kỹ thuật Kiến trúc, Xây dựng, Khảo sát",
        "bn": "স্থাপত্য, নির্মাণ ও জরিপ প্রকৌশল"
    },
    "Kỹ thuật Xây dựng": {
        "vi": "Kỹ thuật Xây dựng",
        "bn": "সিভিল ইঞ্জিনিয়ারিং"
    },
    "Kỹ thuật viên X quang": {
        "vi": "Kỹ thuật viên X quang",
        "bn": "রেডিওলজি টেকনিশিয়ান"
    },
    "Lao động": {
        "vi": "Lao động",
        "bn": "শ্রমিক"
    },
    "Lao động kỳ nghỉ": {
        "vi": "Lao động kỳ nghỉ",
        "bn": "ওয়ার্কিং হলিডে"
    },
    "Lao động nước ngoài lĩnh vực sản xuất": {
        "vi": "Lao động nước ngoài lĩnh vực sản xuất",
        "bn": "উৎপাদন খাতে বিদেশী শ্রমিক"
    },
    "Linh kiện ô tô": {
        "vi": "Linh kiện ô tô",
        "bn": "গাড়ির যন্ত্রাংশ"
    },
    "Luật sư": {
        "vi": "Luật sư",
        "bn": "আইনজীবী"
    },
    "Luật sư luật nước ngoài": {
        "vi": "Luật sư luật nước ngoài",
        "bn": "বিদেশী আইন বিশেষজ্ঞ আইনজীবী"
    },
    "Luật sư nước ngoài": {
        "vi": "Luật sư nước ngoài",
        "bn": "বিদেশী আইনজীবী"
    },
    "Luật sư sở hữu trí tuệ": {
        "vi": "Luật sư sở hữu trí tuệ",
        "bn": "মেধাস্বত্ব আইনজীবী"
    },
    "Làm bánh kẹo": {
        "vi": "Làm bánh kẹo",
        "bn": "মিষ্টি ও কনফেকশনারি তৈরি"
    },
    "Làm nền, móng": {
        "vi": "Làm nền, móng",
        "bn": "ভিত ও ফাউন্ডেশন কাজ"
    },
    "Lái máy xây dựng": {
        "vi": "Lái máy xây dựng",
        "bn": "নির্মাণ যন্ত্র চালানো"
    },
    "Lái máy xúc": {
        "vi": "Lái máy xúc",
        "bn": "এক্সকাভেটর চালানো"
    },
    "Lái máy xúc lật": {
        "vi": "Lái máy xúc lật",
        "bn": "লোডার চালানো"
    },
    "Lái máy ủi": {
        "vi": "Lái máy ủi",
        "bn": "বুলডোজার চালানো"
    },
    "Lái xe": {
        "vi": "Lái xe",
        "bn": "ড্রাইভিং"
    },
    "Lái xe buýt": {
        "vi": "Lái xe buýt",
        "bn": "বাস ড্রাইভিং"
    },
    "Lái xe lu": {
        "vi": "Lái xe lu",
        "bn": "রোড রোলার চালানো"
    },
    "Lái xe tải": {
        "vi": "Lái xe tải",
        "bn": "ট্রাক ড্রাইভিং"
    },
    "Lát đá": {
        "vi": "Lát đá",
        "bn": "পাথর বসানো"
    },
    "Lưu trú khách sạn": {
        "vi": "Lưu trú khách sạn",
        "bn": "হোটেল আবাসন"
    },
    "Lưu trú, khách sạn": {
        "vi": "Lưu trú, khách sạn",
        "bn": "হোটেল ও আবাসন"
    },
    "Lương thực, thực phẩm": {
        "vi": "Lương thực, thực phẩm",
        "bn": "খাদ্য ও পানীয়"
    },
    "Lập trình": {
        "vi": "Lập trình",
        "bn": "প্রোগ্রামিং"
    },
    "Lập trình nhúng": {
        "vi": "Lập trình nhúng",
        "bn": "এমবেডেড প্রোগ্রামিং"
    },
    "Lập trình viên": {
        "vi": "Lập trình viên",
        "bn": "প্রোগ্রামার"
    },
    "Lập văn bản tư pháp": {
        "vi": "Lập văn bản tư pháp",
        "bn": "বিচার বিভাগীয় নথি তৈরি"
    },
    "Lắp bồn tắm": {
        "vi": "Lắp bồn tắm",
        "bn": "বাথটাব ইনস্টলেশন"
    },
    "Lắp ghép cốt thép": {
        "vi": "Lắp ghép cốt thép",
        "bn": "রিইনফোর্সমেন্ট বার সংযোজন"
    },
    "Lắp ráp linh kiện bán dẫn": {
        "vi": "Lắp ráp linh kiện bán dẫn",
        "bn": "সেমিকন্ডাক্টর অ্যাসেম্বলি"
    },
    "Lắp ráp linh kiện ô tô": {
        "vi": "Lắp ráp linh kiện ô tô",
        "bn": "গাড়ির যন্ত্রাংশ সংযোজন"
    },
    "Lắp ráp máy biến áp": {
        "vi": "Lắp ráp máy biến áp",
        "bn": "ট্রান্সফরমার অ্যাসেম্বলি"
    },
    "Lắp ráp máy móc": {
        "vi": "Lắp ráp máy móc",
        "bn": "যন্ত্রপাতি সংযোজন"
    },
    "Lắp ráp thiết bị điện khí": {
        "vi": "Lắp ráp thiết bị điện khí",
        "bn": "ইলেক্ট্রোমেকানিক্যাল যন্ত্রপাতি সংযোজন"
    },
    "Lắp ráp thiết bị điện quay": {
        "vi": "Lắp ráp thiết bị điện quay",
        "bn": "ঘূর্ণায়মান বৈদ্যুতিক যন্ত্র সংযোজন"
    },
    "Lắp ráp thiết bị điện tử": {
        "vi": "Lắp ráp thiết bị điện tử",
        "bn": "ইলেকট্রনিক ডিভাইস অ্যাসেম্বলি"
    },
    "Lắp ráp điện": {
        "vi": "Lắp ráp điện",
        "bn": "ইলেকট্রিক্যাল অ্যাসেম্বলি"
    },
    "Lắp ráp điện tử": {
        "vi": "Lắp ráp điện tử",
        "bn": "ইলেকট্রনিক অ্যাসেম্বলি"
    },
    "Lắp thiết bị đóng, mở": {
        "vi": "Lắp thiết bị đóng, mở",
        "bn": "সুইচিং ডিভাইস ইনস্টলেশন"
    },
    "Lắp tủ điện, tủ điều khiển": {
        "vi": "Lắp tủ điện, tủ điều khiển",
        "bn": "ইলেকট্রিক কন্ট্রোল প্যানেল অ্যাসেম্বলি"
    },
    "Lắp điện lạnh, điều hòa": {
        "vi": "Lắp điện lạnh, điều hòa",
        "bn": "এয়ার কন্ডিশনিং ও কুলিং সিস্টেম ইনস্টলেশন"
    },
    "Lắp đặt lò nung-xây dựng": {
        "vi": "Lắp đặt lò nung-xây dựng",
        "bn": "নির্মাণ চুল্লি ইনস্টলেশন"
    },
    "Lắp đặt máy móc": {
        "vi": "Lắp đặt máy móc",
        "bn": "যন্ত্রপাতি ইনস্টলেশন"
    },
    "Lắp đặt pin năng lượng": {
        "vi": "Lắp đặt pin năng lượng",
        "bn": "সোলার প্যানেল ইনস্টলেশন"
    },
    "Lắp đặt tủ lạnh": {
        "vi": "Lắp đặt tủ lạnh",
        "bn": "ফ্রিজ ইনস্টলেশন"
    },
    "Lắp đặt điều hoà": {
        "vi": "Lắp đặt điều hoà",
        "bn": "এয়ার কন্ডিশনার ইনস্টলেশন"
    },
    "Lắp đặt đường ống": {
        "vi": "Lắp đặt đường ống",
        "bn": "পাইপলাইন ইনস্টলেশন"
    },
    "Lễ tân khách sạn": {
        "vi": "Lễ tân khách sạn",
        "bn": "হোটেল রিসেপশনিস্ট"
    },
    "Lợp mái nhà": {
        "vi": "Lợp mái nhà",
        "bn": "ছাদ ঢাকার কাজ"
    },
    "Lợp ngói": {
        "vi": "Lợp ngói",
        "bn": "টালি বসানো"
    },
    "Marketing": {
        "vi": "Marketing",
        "bn": "মার্কেটিং"
    },
    "May khăn mặt": {
        "vi": "May khăn mặt",
        "bn": "তোয়ালে সেলাই"
    },
    "May mặc": {
        "vi": "May mặc",
        "bn": "পোশাক শিল্প"
    },
    "May quần áo": {
        "vi": "May quần áo",
        "bn": "পোশাক সেলাই"
    },
    "May quần áo nam": {
        "vi": "May quần áo nam",
        "bn": "পুরুষদের পোশাক সেলাই"
    },
    "Mua hàng": {
        "vi": "Mua hàng",
        "bn": "ক্রয়/পার্চেসিং"
    },
    "Máy sản xuất tấm kim loại": {
        "vi": "Máy sản xuất tấm kim loại",
        "bn": "মেটাল শীট উৎপাদন মেশিন"
    },
    "Môi trường làm xưởng": {
        "vi": "Môi trường làm xưởng",
        "bn": "শিল্প পরিবেশ"
    },
    "Mạ kẽm nhúng nóng": {
        "vi": "Mạ kẽm nhúng nóng",
        "bn": "হট-ডিপ গ্যালভানাইজিং"
    },
    "Mạ điện": {
        "vi": "Mạ điện",
        "bn": "ইলেক্ট্রোপ্লেটিং"
    },
    "Mộc cốp pha": {
        "vi": "Mộc cốp pha",
        "bn": "ফর্মওয়ার্ক কাঠমিস্ত্রি কাজ"
    },
    "Mỳ tôm": {
        "vi": "Mỳ tôm",
        "bn": "ইনস্ট্যান্ট নুডলস"
    },
    "Mỹ thuật gia": {
        "vi": "Mỹ thuật gia",
        "bn": "চারুশিল্পী"
    },
    "Nghiên cứu": {
        "vi": "Nghiên cứu",
        "bn": "গবেষণা"
    },
    "Nghiên cứu - phân tích": {
        "vi": "Nghiên cứu - phân tích",
        "bn": "গবেষণা এবং বিশ্লেষণ"
    },
    "Nghiên cứu thị trường": {
        "vi": "Nghiên cứu thị trường",
        "bn": "বাজার গবেষণা"
    },
    "Nghiên cứu thị trường, marketing": {
        "vi": "Nghiên cứu thị trường, marketing",
        "bn": "বাজার গবেষণা ও বিপণন"
    },
    "Nghiên cứu, phân tích": {
        "vi": "Nghiên cứu, phân tích",
        "bn": "গবেষণা এবং বিশ্লেষণ"
    },
    "Nghề có kỹ năng chuyên nghiệp": {
        "vi": "Nghề có kỹ năng chuyên nghiệp",
        "bn": "পেশাদার দক্ষতা ভিত্তিক কাজ"
    },
    "Nghệ sĩ sân khấu": {
        "vi": "Nghệ sĩ sân khấu",
        "bn": "মঞ্চ শিল্পী"
    },
    "Nghệ thuật - nghệ sĩ": {
        "vi": "Nghệ thuật - nghệ sĩ",
        "bn": "শিল্প এবং শিল্পী"
    },
    "Ngư nghiệp": {
        "vi": "Ngư nghiệp",
        "bn": "মৎস্য শিল্প"
    },
    "Người pha chế rượu": {
        "vi": "Người pha chế rượu",
        "bn": "বারটেন্ডার"
    },
    "Người quản gia": {
        "vi": "Người quản gia",
        "bn": "হাউসকিপার"
    },
    "Nha sĩ": {
        "vi": "Nha sĩ",
        "bn": "দন্তচিকিৎসক"
    },
    "Nhiên liệu rắn từ rác": {
        "vi": "Nhiên liệu rắn từ rác",
        "bn": "বর্জ্য থেকে কঠিন জ্বালানি উৎপাদন"
    },
    "Nhiếp ảnh gia": {
        "vi": "Nhiếp ảnh gia",
        "bn": "ফটোগ্রাফার"
    },
    "Nhuộm chỉ": {
        "vi": "Nhuộm chỉ",
        "bn": "সুতা রঞ্জন"
    },
    "Nhuộm vải, đan len": {
        "vi": "Nhuộm vải, đan len",
        "bn": "কাপড় রঞ্জন ও নিটিং"
    },
    "Nhà báo": {
        "vi": "Nhà báo",
        "bn": "সাংবাদিক"
    },
    "Nhà hàng": {
        "vi": "Nhà hàng",
        "bn": "রেস্টুরেন্ট"
    },
    "Nhà ngoại giao": {
        "vi": "Nhà ngoại giao",
        "bn": "কূটনৈতিক"
    },
    "Nhà trị liệu nghề nghiệp": {
        "vi": "Nhà trị liệu nghề nghiệp",
        "bn": "অকুপেশনাল থেরাপিস্ট"
    },
    "Nhà văn": {
        "vi": "Nhà văn",
        "bn": "লেখক"
    },
    "Nhân viên dịch vụ khác (không phân loại nơi khác)": {
        "vi": "Nhân viên dịch vụ khác (không phân loại nơi khác)",
        "bn": "অন্যান্য পরিষেবা কর্মী"
    },
    "Nhân viên sân bay": {
        "vi": "Nhân viên sân bay",
        "bn": "বিমানবন্দর কর্মী"
    },
    "Nhân viên tôn giáo": {
        "vi": "Nhân viên tôn giáo",
        "bn": "ধর্মীয় কর্মী"
    },
    "Nhân viên văn phòng": {
        "vi": "Nhân viên văn phòng",
        "bn": "অফিস কর্মী"
    },
    "Nhạc sĩ": {
        "vi": "Nhạc sĩ",
        "bn": "সুরকার"
    },
    "Nhặt trứng gà": {
        "vi": "Nhặt trứng gà",
        "bn": "মুরগির ডিম সংগ্রহ"
    },
    "Nuôi sò điệp": {
        "vi": "Nuôi sò điệp",
        "bn": "স্ক্যালপ চাষ"
    },
    "Nuôi trồng thủy sản": {
        "vi": "Nuôi trồng thủy sản",
        "bn": "মৎস্য চাষ"
    },
    "Nông lâm ngư nghiệp": {
        "vi": "Nông lâm ngư nghiệp",
        "bn": "কৃষি, বন ও মৎস্য"
    },
    "Nông nghiệp": {
        "vi": "Nông nghiệp",
        "bn": "কৃষি"
    },
    "Nông nghiệp chăn nuôi": {
        "vi": "Nông nghiệp chăn nuôi",
        "bn": "পশুপালন কৃষি"
    },
    "Nông nghiệp trồng trọt": {
        "vi": "Nông nghiệp trồng trọt",
        "bn": "ফসল চাষ কৃষি"
    },
    "Nấu bếp": {
        "vi": "Nấu bếp",
        "bn": "রান্না করা"
    },
    "Nấu nướng": {
        "vi": "Nấu nướng",
        "bn": "রান্নাবান্না"
    },
    "Nặn gốm bằng bánh xoay": {
        "vi": "Nặn gốm bằng bánh xoay",
        "bn": "চাকার সাহায্যে মৃৎশিল্প তৈরি"
    },
    "Nội thất gỗ": {
        "vi": "Nội thất gỗ",
        "bn": "কাঠের আসবাবপত্র"
    },
    "Nội thất gỗ-xây dựng": {
        "vi": "Nội thất gỗ-xây dựng",
        "bn": "নির্মাণে কাঠের ইন্টেরিয়র কাজ"
    },
    "Nữ hộ sinh": {
        "vi": "Nữ hộ sinh",
        "bn": "ধাত্রী"
    },
    "PM (Product Manager)": {
        "vi": "PM (Product Manager)",
        "bn": "প্রোডাক্ট ম্যানেজার (PM)"
    },
    "PO (Product Owner)": {
        "vi": "PO (Product Owner)",
        "bn": "প্রোডাক্ট ওনার (PO)"
    },
    "Phi công": {
        "vi": "Phi công",
        "bn": "পাইলট"
    },
    "Phá dỡ": {
        "vi": "Phá dỡ",
        "bn": "ধ্বংস কাজ"
    },
    "Pháp lý": {
        "vi": "Pháp lý",
        "bn": "আইনগত সহায়ক"
    },
    "Phân tích CAE": {
        "vi": "Phân tích CAE",
        "bn": "CAE বিশ্লেষণ"
    },
    "Phần mềm": {
        "vi": "Phần mềm",
        "bn": "সফটওয়্যার"
    },
    "Phụ bếp": {
        "vi": "Phụ bếp",
        "bn": "রান্নাঘরের সহকারী"
    },
    "Phụ xe": {
        "vi": "Phụ xe",
        "bn": "সহকারী চালক"
    },
    "Quản lý": {
        "vi": "Quản lý",
        "bn": "ব্যবস্থাপনা"
    },
    "Quản lý dọn dẹp": {
        "vi": "Quản lý dọn dẹp",
        "bn": "পরিচ্ছন্নতা ব্যবস্থাপনা"
    },
    "Quản lý kho vận tải": {
        "vi": "Quản lý kho vận tải",
        "bn": "পরিবহন গুদাম ব্যবস্থাপনা"
    },
    "Quản lý khách sạn": {
        "vi": "Quản lý khách sạn",
        "bn": "হোটেল ব্যবস্থাপনা"
    },
    "Quản lý kế hoạch quảng cáo, truyền thông": {
        "vi": "Quản lý kế hoạch quảng cáo, truyền thông",
        "bn": "বিজ্ঞাপন ও মিডিয়া পরিকল্পনা ব্যবস্থাপনা"
    },
    "Quản lý sản xuất máy": {
        "vi": "Quản lý sản xuất máy",
        "bn": "মেশিন উৎপাদন ব্যবস্থাপনা"
    },
    "Quản lý sản xuất tổng hợp": {
        "vi": "Quản lý sản xuất tổng hợp",
        "bn": "সাধারণ উৎপাদন ব্যবস্থাপনা"
    },
    "Quản lý vận chuyển": {
        "vi": "Quản lý vận chuyển",
        "bn": "পরিবহন ব্যবস্থাপনা"
    },
    "Quản lý vận chuyển, dọn dẹp, đóng gói": {
        "vi": "Quản lý vận chuyển, dọn dẹp, đóng gói",
        "bn": "পরিবহন, পরিচ্ছন্নতা ও প্যাকেজিং ব্যবস্থাপনা"
    },
    "Quản lý đóng gói": {
        "vi": "Quản lý đóng gói",
        "bn": "প্যাকেজিং ব্যবস্থাপনা"
    },
    "Quản lý, giám sát thi công công trình": {
        "vi": "Quản lý, giám sát thi công công trình",
        "bn": "নির্মাণ ব্যবস্থাপনা ও তত্ত্বাবধান"
    },
    "Quấn sợi": {
        "vi": "Quấn sợi",
        "bn": "সুতা উইন্ডিং"
    },
    "Quần áo phụ nữ, trẻ em": {
        "vi": "Quần áo phụ nữ, trẻ em",
        "bn": "নারী ও শিশুদের পোশাক"
    },
    "Rác thải, phế liệu, tái chế": {
        "vi": "Rác thải, phế liệu, tái chế",
        "bn": "বর্জ্য, স্ক্র্যাপ ও রিসাইক্লিং"
    },
    "Rèn": {
        "vi": "Rèn",
        "bn": "ফোর্জিং"
    },
    "Rèn bằng búa": {
        "vi": "Rèn bằng búa",
        "bn": "হাতুড়ি দিয়ে ফোর্জিং"
    },
    "Rửa bát": {
        "vi": "Rửa bát",
        "bn": "থালা-বাসন ধোয়া"
    },
    "Salad": {
        "vi": "Salad",
        "bn": "সালাদ"
    },
    "San lấp mặt bằng": {
        "vi": "San lấp mặt bằng",
        "bn": "জমি সমতল করা"
    },
    "Sinh viên thực tập": {
        "vi": "Sinh viên thực tập",
        "bn": "শিক্ষার্থী ইন্টার্ন"
    },
    "Siêu thị": {
        "vi": "Siêu thị",
        "bn": "সুপারমার্কেট"
    },
    "Sơn": {
        "vi": "Sơn",
        "bn": "রং করা"
    },
    "Sơn công trình xây dựng": {
        "vi": "Sơn công trình xây dựng",
        "bn": "নির্মাণ পেইন্টিং"
    },
    "Sơn cầu thép": {
        "vi": "Sơn cầu thép",
        "bn": "স্টিল ব্রিজ পেইন্টিং"
    },
    "Sơn kim loại": {
        "vi": "Sơn kim loại",
        "bn": "মেটাল পেইন্টিং"
    },
    "Sơn phun": {
        "vi": "Sơn phun",
        "bn": "স্প্রে পেইন্টিং"
    },
    "Sơn xây dựng": {
        "vi": "Sơn xây dựng",
        "bn": "নির্মাণ পেইন্টিং"
    },
    "Sản xuất - công nghệ": {
        "vi": "Sản xuất - công nghệ",
        "bn": "উৎপাদন এবং প্রযুক্তি"
    },
    "Sản xuất bánh mì": {
        "vi": "Sản xuất bánh mì",
        "bn": "রুটি উৎপাদন"
    },
    "Sản xuất bê tông": {
        "vi": "Sản xuất bê tông",
        "bn": "কংক্রিট উৎপাদন"
    },
    "Sản xuất bảng mạch in": {
        "vi": "Sản xuất bảng mạch in",
        "bn": "প্রিন্টেড সার্কিট বোর্ড (PCB) উৎপাদন"
    },
    "Sản xuất dưa muối": {
        "vi": "Sản xuất dưa muối",
        "bn": "আচার উৎপাদন"
    },
    "Sản xuất ghế ngồi ô tô": {
        "vi": "Sản xuất ghế ngồi ô tô",
        "bn": "গাড়ির সিট উৎপাদন"
    },
    "Sản xuất hộp bìa cứng": {
        "vi": "Sản xuất hộp bìa cứng",
        "bn": "কার্ডবোর্ড বাক্স উৎপাদন"
    },
    "Sản xuất hộp in": {
        "vi": "Sản xuất hộp in",
        "bn": "প্রিন্টেড বাক্স উৎপাদন"
    },
    "Sản xuất hộp nhãn dán": {
        "vi": "Sản xuất hộp nhãn dán",
        "bn": "লেবেলযুক্ত বাক্স উৎপাদন"
    },
    "Sản xuất linh kiện": {
        "vi": "Sản xuất linh kiện",
        "bn": "উপাদান উৎপাদন"
    },
    "Sản xuất máy dệt kim tròn": {
        "vi": "Sản xuất máy dệt kim tròn",
        "bn": "সার্কুলার নিটিং মেশিন উৎপাদন"
    },
    "Sản xuất mắm cá": {
        "vi": "Sản xuất mắm cá",
        "bn": "মাছের সস উৎপাদন"
    },
    "Sản xuất mỳ": {
        "vi": "Sản xuất mỳ",
        "bn": "নুডলস উৎপাদন"
    },
    "Sản xuất pin năng lượng": {
        "vi": "Sản xuất pin năng lượng",
        "bn": "শক্তি ব্যাটারি উৎপাদন"
    },
    "Sản xuất sản phẩm": {
        "vi": "Sản xuất sản phẩm",
        "bn": "পণ্য উৎপাদন"
    },
    "Sản xuất sản phẩm cho nước ngoài": {
        "vi": "Sản xuất sản phẩm cho nước ngoài",
        "bn": "বিদেশের জন্য পণ্য উৎপাদন"
    },
    "Sản xuất thảm dệt": {
        "vi": "Sản xuất thảm dệt",
        "bn": "বোনা কার্পেট উৎপাদন"
    },
    "Sản xuất thảm nhung nổi": {
        "vi": "Sản xuất thảm nhung nổi",
        "bn": "টাফটেড কার্পেট উৎপাদন"
    },
    "Sản xuất thảm đục lỗ": {
        "vi": "Sản xuất thảm đục lỗ",
        "bn": "নিডল পাঞ্চ কার্পেট উৎপাদন"
    },
    "Sản xuất tất": {
        "vi": "Sản xuất tất",
        "bn": "মোজো উৎপাদন"
    },
    "Sản xuất vải bạt": {
        "vi": "Sản xuất vải bạt",
        "bn": "ক্যানভাস কাপড় উৎপাদন"
    },
    "Sản xuất vải lanh": {
        "vi": "Sản xuất vải lanh",
        "bn": "লিনেন কাপড় উৎপাদন"
    },
    "Sản xuất áo sơ mi": {
        "vi": "Sản xuất áo sơ mi",
        "bn": "শার্ট উৎপাদন"
    },
    "Sản xuất đồ lót": {
        "vi": "Sản xuất đồ lót",
        "bn": "আন্ডারওয়্যার উৎপাদন"
    },
    "Sản xuất, chế tạo, công nghệ": {
        "vi": "Sản xuất, chế tạo, công nghệ",
        "bn": "উৎপাদন এবং প্রযুক্তি"
    },
    "Sản xuất, dịch vụ tổng hợp": {
        "vi": "Sản xuất, dịch vụ tổng hợp",
        "bn": "উৎপাদন এবং সাধারণ সেবা"
    },
    "Sử dụng máy phay": {
        "vi": "Sử dụng máy phay",
        "bn": "মিলিং মেশিন চালানো"
    },
    "Sử dụng máy tiện số": {
        "vi": "Sử dụng máy tiện số",
        "bn": "CNC লেদ মেশিন চালানো"
    },
    "Sử dụng máy tiện thường": {
        "vi": "Sử dụng máy tiện thường",
        "bn": "ম্যানুয়াল লেদ মেশিন চালানো"
    },
    "Sửa chữa dụng cụ": {
        "vi": "Sửa chữa dụng cụ",
        "bn": "সরঞ্জাম মেরামত"
    },
    "Sửa chữa tủ điện": {
        "vi": "Sửa chữa tủ điện",
        "bn": "ইলেকট্রিক্যাল প্যানেল মেরামত"
    },
    "Sửa chữa ô tô": {
        "vi": "Sửa chữa ô tô",
        "bn": "গাড়ি মেরামত"
    },
    "Tester": {
        "vi": "Tester",
        "bn": "টেস্টার"
    },
    "Thi công dán tường": {
        "vi": "Thi công dán tường",
        "bn": "দেয়াল ইনস্টলেশন কাজ"
    },
    "Thi công kết cấu thép": {
        "vi": "Thi công kết cấu thép",
        "bn": "স্টিল স্ট্রাকচার নির্মাণ"
    },
    "Thi công lắp rèm": {
        "vi": "Thi công lắp rèm",
        "bn": "পর্দা ইনস্টলেশন"
    },
    "Thi công móng thép": {
        "vi": "Thi công móng thép",
        "bn": "স্টিল ফাউন্ডেশন নির্মাণ"
    },
    "Thi công điện": {
        "vi": "Thi công điện",
        "bn": "ইলেকট্রিক্যাল ইনস্টলেশন কাজ"
    },
    "Thiết bị khí nén đường sắt": {
        "vi": "Thiết bị khí nén đường sắt",
        "bn": "রেলপথের বায়ুচাপ যন্ত্রপাতি"
    },
    "Thiết kế Auto CAD": {
        "vi": "Thiết kế Auto CAD",
        "bn": "অটো ক্যাড ডিজাইন"
    },
    "Thiết kế Marketing": {
        "vi": "Thiết kế Marketing",
        "bn": "মার্কেটিং ডিজাইন"
    },
    "Thiết kế UI, UX": {
        "vi": "Thiết kế UI, UX",
        "bn": "UI/UX ডিজাইন"
    },
    "Thiết kế bảng mạch in": {
        "vi": "Thiết kế bảng mạch in",
        "bn": "PCB ডিজাইন"
    },
    "Thiết kế cơ khí": {
        "vi": "Thiết kế cơ khí",
        "bn": "মেকানিক্যাল ডিজাইন"
    },
    "Thiết kế thời trang": {
        "vi": "Thiết kế thời trang",
        "bn": "ফ্যাশন ডিজাইন"
    },
    "Thiết kế ô tô": {
        "vi": "Thiết kế ô tô",
        "bn": "অটোমোবাইল ডিজাইন"
    },
    "Thiết kế điện": {
        "vi": "Thiết kế điện",
        "bn": "ইলেকট্রিক্যাল ডিজাইন"
    },
    "Thu hoạch bắp cải": {
        "vi": "Thu hoạch bắp cải",
        "bn": "বাঁধাকপি সংগ্রহ"
    },
    "Thu hoạch cà chua": {
        "vi": "Thu hoạch cà chua",
        "bn": "টমেটো সংগ্রহ"
    },
    "Thu hoạch dâu tây": {
        "vi": "Thu hoạch dâu tây",
        "bn": "স্ট্রবেরি সংগ্রহ"
    },
    "Thu hoạch hoa": {
        "vi": "Thu hoạch hoa",
        "bn": "ফুল সংগ্রহ"
    },
    "Thu hoạch hoa quả": {
        "vi": "Thu hoạch hoa quả",
        "bn": "ফল সংগ্রহ"
    },
    "Thu hoạch nông sản": {
        "vi": "Thu hoạch nông sản",
        "bn": "ফসল কাটা"
    },
    "Thu hoạch rau củ": {
        "vi": "Thu hoạch rau củ",
        "bn": "সবজি সংগ্রহ"
    },
    "Thu ngân": {
        "vi": "Thu ngân",
        "bn": "ক্যাশিয়ার"
    },
    "Thuỷ sản gia công chế biến": {
        "vi": "Thuỷ sản gia công chế biến",
        "bn": "সামুদ্রিক খাদ্য প্রক্রিয়াজাতকরণ"
    },
    "Thuỷ sản khô": {
        "vi": "Thuỷ sản khô",
        "bn": "শুকনো সামুদ্রিক খাদ্য"
    },
    "Thuỷ sản lên men": {
        "vi": "Thuỷ sản lên men",
        "bn": "ফারমেন্টেড সামুদ্রিক খাদ্য"
    },
    "Thuỷ sản sấy khô": {
        "vi": "Thuỷ sản sấy khô",
        "bn": "শুকানো সামুদ্রিক খাদ্য"
    },
    "Thuỷ sản xông khói": {
        "vi": "Thuỷ sản xông khói",
        "bn": "স্মোকড সামুদ্রিক খাদ্য"
    },
    "Thuỷ sản ủ muối": {
        "vi": "Thuỷ sản ủ muối",
        "bn": "লবণযুক্ত সামুদ্রিক খাদ্য"
    },
    "Thái cá sashimi": {
        "vi": "Thái cá sashimi",
        "bn": "সাশিমির জন্য মাছ কাটা"
    },
    "Thương mại nước ngoài": {
        "vi": "Thương mại nước ngoài",
        "bn": "বৈদেশিক বাণিজ্য"
    },
    "Thể dục thể thao": {
        "vi": "Thể dục thể thao",
        "bn": "শারীরিক শিক্ষা এবং খেলাধুলা"
    },
    "Thịt bò": {
        "vi": "Thịt bò",
        "bn": "গরুর মাংস"
    },
    "Thịt gà": {
        "vi": "Thịt gà",
        "bn": "মুরগির মাংস"
    },
    "Thịt lợn": {
        "vi": "Thịt lợn",
        "bn": "শূকরের মাংস"
    },
    "Thợ hàn": {
        "vi": "Thợ hàn",
        "bn": "ওয়েল্ডার"
    },
    "Thợ mộc": {
        "vi": "Thợ mộc",
        "bn": "ছুতার"
    },
    "Thợ mộc xây dựng": {
        "vi": "Thợ mộc xây dựng",
        "bn": "নির্মাণ কাঠমিস্ত্রি"
    },
    "Thợ nề": {
        "vi": "Thợ nề",
        "bn": "রাজমিস্ত্রি"
    },
    "Thợ xây": {
        "vi": "Thợ xây",
        "bn": "রাজমিস্ত্রি"
    },
    "Thức ăn cơ sở y tế": {
        "vi": "Thức ăn cơ sở y tế",
        "bn": "চিকিৎসা প্রতিষ্ঠানের খাদ্য"
    },
    "Thực phẩm": {
        "vi": "Thực phẩm",
        "bn": "খাদ্য শিল্প"
    },
    "Thực phẩm sữa": {
        "vi": "Thực phẩm sữa",
        "bn": "দুগ্ধজাত পণ্য"
    },
    "Thực phẩm trứng": {
        "vi": "Thực phẩm trứng",
        "bn": "ডিমজাত পণ্য"
    },
    "Thực tập lái xe": {
        "vi": "Thực tập lái xe",
        "bn": "ড্রাইভিং ইন্টার্নশিপ"
    },
    "Tiếp thị (sales) doanh nghiệp": {
        "vi": "Tiếp thị (sales) doanh nghiệp",
        "bn": "কর্পোরেট বিক্রয়"
    },
    "Trao đổi văn hóa quốc tế": {
        "vi": "Trao đổi văn hóa quốc tế",
        "bn": "আন্তর্জাতিক সাংস্কৃতিক বিনিময়"
    },
    "Truyền thông": {
        "vi": "Truyền thông",
        "bn": "মিডিয়া ও যোগাযোগ"
    },
    "Trát vữa": {
        "vi": "Trát vữa",
        "bn": "প্লাস্টারিং"
    },
    "Trí tuệ nhân tạo": {
        "vi": "Trí tuệ nhân tạo",
        "bn": "কৃত্রিম বুদ্ধিমত্তা"
    },
    "Trắc địa, khảo sát": {
        "vi": "Trắc địa, khảo sát",
        "bn": "জরিপ ও ম্যাপিং"
    },
    "Trồng cây ăn quả": {
        "vi": "Trồng cây ăn quả",
        "bn": "ফল গাছ চাষ"
    },
    "Trồng hoa": {
        "vi": "Trồng hoa",
        "bn": "ফুল চাষ"
    },
    "Trồng nấm": {
        "vi": "Trồng nấm",
        "bn": "মাশরুম চাষ"
    },
    "Trồng nấm công nghệ cao": {
        "vi": "Trồng nấm công nghệ cao",
        "bn": "উচ্চ প্রযুক্তিতে মাশরুম চাষ"
    },
    "Trồng rau củ": {
        "vi": "Trồng rau củ",
        "bn": "সবজি চাষ"
    },
    "Trồng rau củ quả ngoài trời": {
        "vi": "Trồng rau củ quả ngoài trời",
        "bn": "খোলা মাঠে সবজি ও ফল চাষ"
    },
    "Trồng rau củ quả trong nhà kính": {
        "vi": "Trồng rau củ quả trong nhà kính",
        "bn": "গ্রিনহাউসে সবজি ও ফল চাষ"
    },
    "Trồng trọt nhà kính": {
        "vi": "Trồng trọt nhà kính",
        "bn": "গ্রীনহাউসে চাষাবাদ"
    },
    "Trộn và cán cao su": {
        "vi": "Trộn và cán cao su",
        "bn": "রাবার মিশ্রণ ও রোলিং"
    },
    "Trợ lý y tá": {
        "vi": "Trợ lý y tá",
        "bn": "নার্সিং সহকারী"
    },
    "Tài chính - kế toán - bảo hiểm": {
        "vi": "Tài chính - kế toán - bảo hiểm",
        "bn": "অর্থায়ন, অ্যাকাউন্টিং এবং বীমা"
    },
    "Tài chính, bảo hiểm": {
        "vi": "Tài chính, bảo hiểm",
        "bn": "অর্থ ও বীমা"
    },
    "Tài chính, kế toán, bảo hiểm": {
        "vi": "Tài chính, kế toán, bảo hiểm",
        "bn": "ফাইন্যান্স ও ইনস্যুরেন্স"
    },
    "Tư vấn bảo hiểm xã hội": {
        "vi": "Tư vấn bảo hiểm xã hội",
        "bn": "সামাজিক বীমা পরামর্শ"
    },
    "Tấm kim loại kiến trúc": {
        "vi": "Tấm kim loại kiến trúc",
        "bn": "স্থাপত্য ধাতব শীট"
    },
    "Tấm kim loại ống gió": {
        "vi": "Tấm kim loại ống gió",
        "bn": "ডাক্ট মেটাল শীট"
    },
    "Tấm thép nhà xưởng": {
        "vi": "Tấm thép nhà xưởng",
        "bn": "কারখানার ইস্পাত শীট"
    },
    "Tấm thép xây dựng": {
        "vi": "Tấm thép xây dựng",
        "bn": "নির্মাণ ইস্পাত শীট"
    },
    "Tẩm ướp thuỷ sản": {
        "vi": "Tẩm ướp thuỷ sản",
        "bn": "সামুদ্রিক খাদ্য মেরিনেশন"
    },
    "Tự động hoá": {
        "vi": "Tự động hoá",
        "bn": "অটোমেশন"
    },
    "Viết quảng cáo": {
        "vi": "Viết quảng cáo",
        "bn": "কপিরাইটিং"
    },
    "Viễn thông": {
        "vi": "Viễn thông",
        "bn": "টেলিযোগাযোগ"
    },
    "Việc làm bán chuyên nghiệp": {
        "vi": "Việc làm bán chuyên nghiệp",
        "bn": "আধা-পেশাদার কাজ"
    },
    "Vận chuyển hàng hóa": {
        "vi": "Vận chuyển hàng hóa",
        "bn": "পণ্য পরিবহন"
    },
    "Vận hành máy": {
        "vi": "Vận hành máy",
        "bn": "মেশিন অপারেশন"
    },
    "Vận hành máy CNC": {
        "vi": "Vận hành máy CNC",
        "bn": "CNC মেশিন অপারেশন"
    },
    "Vận hành máy ép": {
        "vi": "Vận hành máy ép",
        "bn": "প্রেস মেশিন অপারেশন"
    },
    "Vận hành máy ép nhựa": {
        "vi": "Vận hành máy ép nhựa",
        "bn": "প্লাস্টিক ইনজেকশন মেশিন অপারেশন"
    },
    "Vận hành robot": {
        "vi": "Vận hành robot",
        "bn": "রোবট অপারেশন"
    },
    "Vận hành web thương mại điện tử": {
        "vi": "Vận hành web thương mại điện tử",
        "bn": "ই-কমার্স ওয়েবসাইট অপারেশন"
    },
    "Vận động viên chuyên nghiệp": {
        "vi": "Vận động viên chuyên nghiệp",
        "bn": "পেশাদার ক্রীড়াবিদ"
    },
    "Vận động viên nghiệp dư": {
        "vi": "Vận động viên nghiệp dư",
        "bn": "অ্যামেচার ক্রীড়াবিদ"
    },
    "Vật liệu composite nhiều lớp": {
        "vi": "Vật liệu composite nhiều lớp",
        "bn": "বহুস্তর কম্পোজিট উপাদান"
    },
    "Vật lý trị liệu": {
        "vi": "Vật lý trị liệu",
        "bn": "ফিজিওথেরাপিস্ট"
    },
    "Vệ sinh phòng học": {
        "vi": "Vệ sinh phòng học",
        "bn": "ক্লাসরুম পরিষ্কার"
    },
    "Vệ sinh răng miệng": {
        "vi": "Vệ sinh răng miệng",
        "bn": "ডেন্টাল হাইজিনিস্ট"
    },
    "Vệ sinh tòa nhà": {
        "vi": "Vệ sinh tòa nhà",
        "bn": "বিল্ডিং পরিষ্কার করা"
    },
    "Xây dựng": {
        "vi": "Xây dựng",
        "bn": "নির্মাণ শিল্প"
    },
    "Xây dựng dân dụng": {
        "vi": "Xây dựng dân dụng",
        "bn": "সিভিল নির্মাণ"
    },
    "Xây dựng tổng hợp": {
        "vi": "Xây dựng tổng hợp",
        "bn": "সাধারণ নির্মাণ কাজ"
    },
    "Xây trát": {
        "vi": "Xây trát",
        "bn": "প্লাস্টারিং"
    },
    "Xử lý nhiệt bề mặt": {
        "vi": "Xử lý nhiệt bề mặt",
        "bn": "সারফেস হিট ট্রিটমেন্ট"
    },
    "Xử lý nhiệt một phần": {
        "vi": "Xử lý nhiệt một phần",
        "bn": "আংশিক হিট ট্রিটমেন্ট"
    },
    "Xử lý nhiệt tổng thể": {
        "vi": "Xử lý nhiệt tổng thể",
        "bn": "সামগ্রিক হিট ট্রিটমেন্ট"
    },
    "Xử lý điện hóa nhôm": {
        "vi": "Xử lý điện hóa nhôm",
        "bn": "অ্যালুমিনিয়াম ইলেক্ট্রোকেমিক্যাল ট্রিটমেন্ট"
    },
    "Y tá": {
        "vi": "Y tá",
        "bn": "নার্স"
    },
    "Y tá EPA": {
        "vi": "Y tá EPA",
        "bn": "EPA নার্স"
    },
    "Y tá EPA dự bị": {
        "vi": "Y tá EPA dự bị",
        "bn": "EPA প্রশিক্ষণার্থী নার্স"
    },
    "Y tá sức khoẻ cộng đồng": {
        "vi": "Y tá sức khoẻ cộng đồng",
        "bn": "জনস্বাস্থ্য নার্স"
    },
    "Y tế - điều dưỡng": {
        "vi": "Y tế - điều dưỡng",
        "bn": "স্বাস্থ্যসেবা এবং নার্সিং"
    },
    "Y tế lâm sàng": {
        "vi": "Y tế lâm sàng",
        "bn": "ক্লিনিক্যাল মেডিকেল"
    },
    "Y tế, điều dưỡng": {
        "vi": "Y tế, điều dưỡng",
        "bn": "স্বাস্থ্যসেবা এবং নার্সিং"
    },
    "Ép dập kim loại": {
        "vi": "Ép dập kim loại",
        "bn": "মেটাল প্রেসিং ও স্ট্যাম্পিং"
    },
    "Ô tô": {
        "vi": "Ô tô",
        "bn": "অটোমোবাইল প্রযুক্তি"
    },
    "Điều dưỡng": {
        "vi": "Điều dưỡng",
        "bn": "নার্সিং"
    },
    "Điều dưỡng có chứng chỉ": {
        "vi": "Điều dưỡng có chứng chỉ",
        "bn": "প্রত্যয়িত নার্স"
    },
    "Điều dưỡng dự bị học EPA": {
        "vi": "Điều dưỡng dự bị học EPA",
        "bn": "EPA প্রশিক্ষণার্থী নার্স"
    },
    "Điều dưỡng, hộ lý EPA": {
        "vi": "Điều dưỡng, hộ lý EPA",
        "bn": "EPA নার্স ও পরিচর্যাকারী"
    },
    "Điều dưỡng, hộ lý EPA dự bị": {
        "vi": "Điều dưỡng, hộ lý EPA dự bị",
        "bn": "EPA প্রশিক্ষণার্থী নার্স ও পরিচর্যাকারী"
    },
    "Điều hành": {
        "vi": "Điều hành",
        "bn": "অপারেশনস"
    },
    "Điện": {
        "vi": "Điện",
        "bn": "বিদ্যুৎ"
    },
    "Điện cơ khí hỗ trợ chuyển nhà": {
        "vi": "Điện cơ khí hỗ trợ chuyển nhà",
        "bn": "বাড়ি স্থানান্তরে ইলেকট্রোমেকানিক্যাল সহায়তা"
    },
    "Điện nội thất": {
        "vi": "Điện nội thất",
        "bn": "অভ্যন্তরীণ বৈদ্যুতিক কাজ"
    },
    "Điện tử": {
        "vi": "Điện tử",
        "bn": "ইলেকট্রনিক্স"
    },
    "Điện, kỹ thuật điện": {
        "vi": "Điện, kỹ thuật điện",
        "bn": "বিদ্যুৎ ও ইলেকট্রিক্যাল ইঞ্জিনিয়ারিং"
    },
    "Điện, điện tử": {
        "vi": "Điện, điện tử",
        "bn": "ইলেকট্রিক্যাল ও ইলেকট্রনিক্স"
    },
    "Đánh bắt cá": {
        "vi": "Đánh bắt cá",
        "bn": "মাছ ধরা"
    },
    "Đánh cá dây câu dài": {
        "vi": "Đánh cá dây câu dài",
        "bn": "দীর্ঘ লাইনের মাধ্যমে মাছ ধরা"
    },
    "Đánh cá lưới kéo": {
        "vi": "Đánh cá lưới kéo",
        "bn": "ট্রল জাল দিয়ে মাছ ধরা"
    },
    "Đánh cá lưới rê": {
        "vi": "Đánh cá lưới rê",
        "bn": "ড্রিফট জাল দিয়ে মাছ ধরা"
    },
    "Đánh cá lưới sào": {
        "vi": "Đánh cá lưới sào",
        "bn": "খুঁটি জাল দিয়ে মাছ ধরা"
    },
    "Đánh cá lưới thả": {
        "vi": "Đánh cá lưới thả",
        "bn": "ফেলে দেওয়া জাল দিয়ে মাছ ধরা"
    },
    "Đóng gói": {
        "vi": "Đóng gói",
        "bn": "প্যাকেজিং"
    },
    "Đóng gói bánh kẹo": {
        "vi": "Đóng gói bánh kẹo",
        "bn": "মিষ্টি ও কনফেকশনারি প্যাকেজিং"
    },
    "Đóng gói cafe": {
        "vi": "Đóng gói cafe",
        "bn": "কফি প্যাকেজিং"
    },
    "Đóng gói công nghiệp": {
        "vi": "Đóng gói công nghiệp",
        "bn": "শিল্প প্যাকেজিং"
    },
    "Đóng gói gạo": {
        "vi": "Đóng gói gạo",
        "bn": "চাল প্যাকেজিং"
    },
    "Đóng gói linh kiện": {
        "vi": "Đóng gói linh kiện",
        "bn": "অংশ প্যাকেজিং"
    },
    "Đóng gói mỹ phẩm": {
        "vi": "Đóng gói mỹ phẩm",
        "bn": "প্রসাধনী প্যাকেজিং"
    },
    "Đóng gói rau": {
        "vi": "Đóng gói rau",
        "bn": "সবজি প্যাকেজিং"
    },
    "Đóng gói rau củ": {
        "vi": "Đóng gói rau củ",
        "bn": "সবজি ও শাকসবজি প্যাকেজিং"
    },
    "Đóng gói rong biển": {
        "vi": "Đóng gói rong biển",
        "bn": "সামুদ্রিক শৈবাল প্যাকেজিং"
    },
    "Đóng gói thanh cua": {
        "vi": "Đóng gói thanh cua",
        "bn": "ক্র্যাব স্টিক প্যাকেজিং"
    },
    "Đóng hộp thực phẩm": {
        "vi": "Đóng hộp thực phẩm",
        "bn": "খাদ্য ক্যানিং"
    },
    "Đóng sách": {
        "vi": "Đóng sách",
        "bn": "বই বাঁধাই"
    },
    "Đóng tàu": {
        "vi": "Đóng tàu",
        "bn": "জাহাজ নির্মাণ"
    },
    "Đúc": {
        "vi": "Đúc",
        "bn": "ঢালাই"
    },
    "Đúc gang": {
        "vi": "Đúc gang",
        "bn": "কাস্ট আয়রন ঢালাই"
    },
    "Đúc gốm bằng áp lực": {
        "vi": "Đúc gốm bằng áp lực",
        "bn": "চাপ দিয়ে সিরামিক ঢালাই"
    },
    "Đúc khuôn": {
        "vi": "Đúc khuôn",
        "bn": "মোল্ড কাস্টিং"
    },
    "Đúc khuôn buồng lạnh": {
        "vi": "Đúc khuôn buồng lạnh",
        "bn": "কোল্ড চেম্বার ডাই কাস্টিং"
    },
    "Đúc khuôn buồng nóng": {
        "vi": "Đúc khuôn buồng nóng",
        "bn": "হট চেম্বার ডাই কাস্টিং"
    },
    "Đúc khuôn cao su": {
        "vi": "Đúc khuôn cao su",
        "bn": "রাবার ছাঁচ ঢালাই"
    },
    "Đúc kim loại màu": {
        "vi": "Đúc kim loại màu",
        "bn": "নন-ফেরাস মেটাল কাস্টিং"
    },
    "Đúc nhựa": {
        "vi": "Đúc nhựa",
        "bn": "প্লাস্টিক ঢালাই"
    },
    "Đúc nhựa cán xếp chồng": {
        "vi": "Đúc nhựa cán xếp chồng",
        "bn": "স্তরায়িত প্লাস্টিক ঢালাই"
    },
    "Đúc nhựa nén": {
        "vi": "Đúc nhựa nén",
        "bn": "কম্প্রেশন প্লাস্টিক ঢালাই"
    },
    "Đúc nhựa thổi phồng": {
        "vi": "Đúc nhựa thổi phồng",
        "bn": "ব্লো মোল্ডিং (ফোলানো)"
    },
    "Đúc nhựa thổi định hình": {
        "vi": "Đúc nhựa thổi định hình",
        "bn": "ব্লো মোল্ডিং (আকৃতি নির্ধারণ)"
    },
    "Đường ống": {
        "vi": "Đường ống",
        "bn": "পাইপলাইন"
    },
    "Đường ống nhà máy": {
        "vi": "Đường ống nhà máy",
        "bn": "কারখানার পাইপলাইন"
    },
    "Đường ống nước": {
        "vi": "Đường ống nước",
        "bn": "পানির পাইপলাইন"
    },
    "Đường ống xây dựng": {
        "vi": "Đường ống xây dựng",
        "bn": "নির্মাণ পাইপলাইন"
    },
    "Đường ống điều hoà": {
        "vi": "Đường ống điều hoà",
        "bn": "এয়ার কন্ডিশনিং পাইপলাইন"
    },
    "Đại lý thủ tục hàng hải": {
        "vi": "Đại lý thủ tục hàng hải",
        "bn": "সামুদ্রিক পদ্ধতি এজেন্ট"
    },
    "Đậu hũ": {
        "vi": "Đậu hũ",
        "bn": "টোফু"
    },
    "Đặt lưới đánh cá": {
        "vi": "Đặt lưới đánh cá",
        "bn": "মাছ ধরার জাল বসানো"
    },
    "Đồ konbini": {
        "vi": "Đồ konbini",
        "bn": "কনবিনি খাবার"
    },
    "Đồ uống": {
        "vi": "Đồ uống",
        "bn": "পানীয়"
    },
    "Đồ ăn kèm": {
        "vi": "Đồ ăn kèm",
        "bn": "সাইড ডিশ"
    },
    "Đổ bê tông áp lực": {
        "vi": "Đổ bê tông áp lực",
        "bn": "চাপ দিয়ে কংক্রিট ঢালা"
    },
    "Đổ nhựa đường": {
        "vi": "Đổ nhựa đường",
        "bn": "অ্যাসফাল্ট বিছানো"
    },
    "Đục lỗ hộp in": {
        "vi": "Đục lỗ hộp in",
        "bn": "প্রিন্টেড বাক্সে ছিদ্র করা"
    },
    "Đục nhựa ép phun": {
        "vi": "Đục nhựa ép phun",
        "bn": "ইনজেকশন মোল্ডেড প্লাস্টিক ছিদ্রকরণ"
    },
    "Ốp lát gạch": {
        "vi": "Ốp lát gạch",
        "bn": "টাইল বসানো"
    }
}
